import React from 'react';
import {find as _find, join as _join} from 'lodash';

import {IconAngleRight} from '@appComponents/IconCollection';

export const renderUsages = (usages) => {
    return (
        <div>
            {prepareUsages(usages).map((deviceCategory, i) =>
                <p key={i} className='--marginBottom-5'>
                    {deviceCategory.name} <IconAngleRight/> {_join(deviceCategory.way_of_transmissions, ' / ')}
                </p>
            )}
        </div>
    );
};

export const prepareUsages = (usages) => {
    let usagesArray = [];

    usages.map((usage) => {
        let deviceCategory = _find(usagesArray, {name: usage.device_category.name});

        (deviceCategory)
            ? deviceCategory.way_of_transmissions.push(usage.way_of_transmission.name)
            : usagesArray.push({
                name: usage.device_category.name,
                way_of_transmissions: [usage.way_of_transmission.name],
            });
    });

    return usagesArray;
};
